import { Breadcrumb } from 'antd';
import { noop } from 'lodash';
import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { generalCreators } from '../../../../redux/general/general-action';
import { MODAL_TYPE } from '../../../../redux/general/general-constant';
import { GENERAL_STATE_KEY } from '../../../../redux/general/general-reducer';
import { RBHBox, RBHText } from '../../../../shared/components';
import styleText from '../../../../shared/components/rbh-text/styles';
import { mainCreators } from '../../../main-action';
import { MAIN_STATE_KEY } from '../../../main-reducer';
import { catCreators } from '../../FoodCategory/redux/cat-action';
import { FormAddEditMenu } from '../components/FormAddEdit';
import styles from './styles';

export const AddMenuScreen: React.FC<Props> = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(mainCreators.setMainState(MAIN_STATE_KEY.HEADER_MENU, 5));
    dispatch(catCreators.callFoodCategory(pushToFoodMenu, false));
  }, []);


  const dispatchModal = (path: any) => {
    dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      onOk: () => history.push(path),
      type: MODAL_TYPE.CONFIRM_EDIT
    }));
  };

  const pushToFoodMenu = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    history.push('/main/foodmenu');
  };

  return (
    <RBHBox>
      <RBHBox>
        <Breadcrumb style={styleText.breadCrumb}>
          <Breadcrumb.Item>
            <a data-testid={'breadcrumb_homepage_add'} id={'breakcrumb_menu_tohomepage'} style={styleText.breadCrumbItemLink}
              onClick={() => dispatchModal('/main')}>
              <FormattedMessage id={'main.main'} />
            </a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <a data-testid={'breadcrumb_menu_add'} id={'breakcrumb_menu'} style={styleText.breadCrumbItemLink} onClick={() => dispatchModal('/main/foodmenu')}>
              <FormattedMessage id={'main.foodmenu.landing.breadcrumb'} />
            </a>

          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span data-testid={'breadcrumb_menu_add_add'} id={'breakcrumb_add_menu'} style={styleText.breadCrumbItem}>
              <FormattedMessage id={'main.foodmenu.addmenu.breadcrumb'} />
            </span>
          </Breadcrumb.Item>
        </Breadcrumb>
      </RBHBox>
      <RBHBox style={styles.header}>
        <RBHText data-testid={'add_menu_header'} id={'add_menu_header'} style={styleText.headerText} text={'main.foodmenu.addmenu.header'} />
      </RBHBox>
      <RBHBox style={styles.qaDescBox}>
        <RBHText data-testid={'menu_qc_desc'} id={'menu_qc_desc'} style={styles.qaDesc}
          text={'main.foodmenu.addEdit.qc.desc'} />
      </RBHBox>
      <RBHBox style={styles.formWrapper}>
        <FormAddEditMenu onSuccessCallback={pushToFoodMenu} onCancel={dispatchModal} />
      </RBHBox>
    </RBHBox>
  );
};

type Props = {};
